import { createSelector } from '@ngrx/store';
import { seatMapRootSelector } from '@seat-map/store/selectors/seat-map-detail.selector';
import { SeatMapModuleState } from '@seat-map/store/state/seat-map-module.state';

export const getSeatMapState = createSelector(
  seatMapRootSelector,
  (state: SeatMapModuleState) => state.ui
);

